import React from 'react';
import { useSelector } from 'react-redux';

import { ALL_TYPES } from './constants';

import * as commonSelectors from '@/modules/common/redux/selectors/common';

import Container from './components/Container/Container';

type Props = {
  type: (typeof ALL_TYPES)[number];
};

function Ad({ type }: Props) {
  const ad = useSelector(commonSelectors.adSelector);
  const adHubId = useSelector(commonSelectors.adHubIdSelector);
  const adWidgetId = useSelector(commonSelectors.adWidgetIdSelector);

  return ad && adHubId && adWidgetId && <Container id={type} />;
}

export default Ad;
